import React from 'react'

const Favoritos = () => {
  return (
    <div>Favoritos</div>
  )
}
export default Favoritos;